export const CREATE_ACTIVITY = 'createActivity';
export const CREATE_ACTIVITIES = 'createActivities';
export const FETCH_ACTIVITY_BY_ID = 'fetchActivityById';
export const DELETE_ACTIVITY_BY_ID = 'deleteActivityById';
export const UPDATE_ACTIVITY_BY_ID = 'updateActivityById';
export const FETCH_ACTIVITY_BILL_ITEMS = 'fetchActivityBillItems';
